import cx from "classnames";
import { useTranslation } from "react-i18next";

import { ConfigProvider, Space, Tabs } from "antd";

import styles from "../styles/EmployeeMenu.module.css";
import MyTabsMenu from "components/elements/MyTabs/MyTabsMenu";
import { useSelector } from "react-redux";

function EmployeeMenu({ selectedMenu = "employee_info", onSelectMenu = () => { } }) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  function getItem(rules, label, key) {
    let list = [...roles]
    if (!list.includes(rules)) {
      return null
    }
    return {
      // rules: rules,
      label: label,
      key: key,
    };
  }
  const EMPLOYEE_MENU_LIST = [
    getItem("ACCESS_EMPLOYEE|EMPLOYEE_INFO", t('employee.employee_info.header'), 'employee_info'),
    getItem("ACCESS_EMPLOYEE|EMPLOYMENT", t('employee.employment.header'), 'employment'),
    getItem("ACCESS_EMPLOYEE|WORK_IN", t('employee.workin.header'), 'workin'),
    getItem("ACCESS_EMPLOYEE|PERFORMANCE", t('employee.performance.header'), 'performance'),
    getItem("ACCESS_EMPLOYEE|DOCUMENT", t('employee.document.header'), 'document'),
    getItem("ACCESS_EMPLOYEE|SALARY", t('employee.salary.header'), 'salary'),
    getItem("ACCESS_EMPLOYEE|WELFARE", t('employee.welfare.header'), 'welfare'),
    getItem("ACCESS_EMPLOYEE|FUND", t('employeeFund.header'), 'employeeFund')
  ].filter(item => item !== null);

  return (
    // <MyTabsMenu menuList={EMPLOYEE_MENU_LIST} onChange={onSelectMenu} ></MyTabsMenu>
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            itemHoverColor: "var(--tab-color)",
            itemActiveColor: "var(--tab-color)"
          },
        },
      }}
    >
      <Tabs items={EMPLOYEE_MENU_LIST} onChange={onSelectMenu} activeKey={selectedMenu} />
    </ConfigProvider>
  );
}

export default EmployeeMenu;
